import { getCookie } from '../helpers/unit';

/**
 * 基础状态树结构
 * @type {Object}
 */
export const stateStructure = {
	base: {
		modal: {
			overlay: {
				display: false
			},
			loading: {
				display: false
			},
			alert: {
				display: false
			},
			confirm:{
				display: false
			},
			natigator: {
				display: false
			},
			iframe:{
				display: false
			},
			transfer:{
				display: false
			}
		},
		toast:{
			display: false
		},
		dragFrame:{
			display: false
		},
		sound:{
			play: false
		},
		route:{
			history: []
		},
		ui:{
			random: _.random(10000),
			skin: getCookie('skin') || 'sc-background-01',
			display: false
		},
		config:{
			soundNotice: getCookie('notice-sound') == '0' ? false : true,
			winnerNotice: getCookie('notice-winner') == '0' ? false : true,
			showBalance: getCookie('show-balance') == '0' ? false : true,
			showBetAnimation: getCookie('show-bet-animation') == '0' ? false : true,
		},
		ads: []
	},
	user: {
		withdraw_type_data:{status:true,availablebalance:0,digitalrest:0},
		sessid: getCookie('_sessionHandler'),
		menus: null,
		info: {},
		chat: {},
		balance: {
			pt: 0,
			ag: 0,
			ibc: 0,
			bbin: 0,
			kgame: 0,
			yy: 0,
			wm: 0,
			wali:0
		},
		platform_profile: {
			pt: {
				available: false
			},
			ag: {
				available: true
			},
			ibc:{
				available: false
			},
			bbin:{
				available: false
			},
			kgame:{
				available: false
			},
      yy:{
				available: false
			},
			wm:{
				available: false
			},
			lottery:{
				available: true
			},
			wali:{
				available: false
			},
		}
	},
	activity:{
		list: null
	},
	game:{
		pt: {
			hot: [],
			ads: [],
			contents: null
		},
		ag: {
			hot: [],
			ads: [],
			contents: null
		},
		bbin: {
			hot: [],
			ads: [],
			contents: null
		},
		ibc: {

		},
		categories: []
	},
	lottery: {
		sale_info:[],
		lottery_history: {}
	},
	method:{
		staticLoadDone: false,
		dynamicLoadDone: false,
		autheError: null,
		windows: {}
	},
	report:{

	},
	dashboard: {},
	common:{
		favorites: {},
		banners: [],
		bulletins: {
			count: 0,
			list:[]
		},
		winners: [],
		showWinner: true,
		push_info: {},
		captcha: {},
		showCaptcha: false,
		checkDomainResult:{},
		settings:{
			agreement: "",
			air_download_url: "",
			app_download_url: "",
			client_version: '',
			customer_service_url: "",
			h5_welcome_url: "",
			hangup_app_qr_url: "",
			hangup_manual_download_url: "",
			hangup_mobile_download_url: "",
			hangup_pc_download_url: "",
			hangup_colorful_download_url:'',
			pc_client_download_url: "",
			pc_client_download_url_1: "",
			pc_client_download_url_2: "",
			public_key: '',
			version: '',
		}
	},
	push: {
		push_status: false
	},

}
